export enum CsasDtoTransactionSectionState {
  SectionStart = 'SectionStart',
  PreparingSection = 'PreparingSection',
  SectionDisabled = 'SectionDisabled',
  SectionEnabled = 'SectionEnabled',
  SectionProcessed = 'SectionProcessed',
}
